import { type Sprite } from 'pixi.js';
import applyDisplayObjectProps from './applyDisplayObjectProps';
import { type SpriteProps } from './DisplayObjectProps';
import applyAnchor from './apply/applyAnchor';
import { setTextureWithLoadingFallback } from './dynamicTextureLoading';

export default function applySpriteProps<T extends Sprite>(sprite: T, props: SpriteProps): T {
  if (sprite.destroyed) return sprite;

  if (props.texture !== undefined) {
    if (typeof props.texture === 'string') {
      void setTextureWithLoadingFallback(sprite, props.texture);
    } else {
      sprite.texture = props.texture;
    }
  }

  applyDisplayObjectProps(sprite, props);

  applyAnchor(sprite, props.anchor);

  if (props.tint !== undefined) sprite.tint = props.tint;
  if (props.blendMode !== undefined) sprite.blendMode = props.blendMode;
  if (props.width !== undefined) sprite.width = props.width;
  if (props.height !== undefined) sprite.height = props.height;

  return sprite;
}
